import { render, staticRenderFns } from "./CategoryLevel3.vue?vue&type=template&id=b36e45b2&scoped=true&"
import script from "./CategoryLevel3.vue?vue&type=script&lang=js&"
export * from "./CategoryLevel3.vue?vue&type=script&lang=js&"
import style0 from "./CategoryLevel3.vue?vue&type=style&index=0&id=b36e45b2&prod&lang=scss&scoped=true&"
import style1 from "./CategoryLevel3.vue?vue&type=style&index=1&id=b36e45b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36e45b2",
  null
  
)

export default component.exports
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QScrollArea,QTabs,QTab});
